import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gaweb-is-return',
  template: `
        <div class="btn-group btn-group-justified" >
            <label class="btn btn-toggle" (click)="value = false" [ngClass]="getStyles(false)">ONE WAY</label>
            <label class="btn btn-toggle" (click)="value = true" [ngClass]="getStyles(true)">RETURN</label>
        </div>
  `,
   providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IsReturnComponent),
            multi: true
        }
    ]
})
export class IsReturnComponent implements OnInit, ControlValueAccessor {
  @Input('value') _value: boolean = false;
  get value() {
    return this._value;
  }
  set value(val: boolean) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() { }

  ngOnInit() {
  }

  getStyles(isReturn){
    if(this.value && isReturn){
      return ['active']
    } else if( !this.value && !isReturn){
      return ['active']
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/is-return/is-return.component.ts